import {
    actionTypes as asyncTypes,
    isAsyncOperation,
    isAsyncComplete,
  } from "async-ops";
import { GET_DELETED_ENTITIES_LIST } from "../services/get-deleted-entities-list";

const initialState = {
    isLoading: false,
    deletedEntitiesList: []
}

export default function(state = initialState, action) {
    switch (action.type) {
        case asyncTypes.OPERATION:
        case asyncTypes.COMPLETE:
        case asyncTypes.FAILURE:
              if (isAsyncOperation(GET_DELETED_ENTITIES_LIST)(action)) {
                return { ...state, deletedEntitiesList: [] };
              }
              if (isAsyncComplete(GET_DELETED_ENTITIES_LIST)(action)) {
                const response = action.response;
                return { ...state, deletedEntitiesList: response };
              }
              return state;
              default:
                return state;
    }
}